'use strict';
var initialized = false;
var addProductToCart = require('./product/addToCart'),
    carouselOptions = require('_core_ext/config-carousel'),
    carousel = require('_core_ext/carousel');

function initializeEvents() {
    $('.js-recommendation-input').on('click', function() {
        var id = $(this).attr('id').split('_')[0];
        var tabClass = $(this).data('tab-class');
        var $activeTab = $(this).closest('.js-recommendation').find('.' + tabClass);
        var $carouselToBeInited;

        $(this).closest('.js-recommendation').removeClass (function (index, className) {
            return (className.match (/(^|\s)carousel-\S+/g) || []).join(' ');
        });
        $(this).closest('.js-recommendation').addClass(id);

        if ($activeTab.length) {
            $carouselToBeInited = $activeTab.find(carouselOptions.skipClass);
            if ($carouselToBeInited && $carouselToBeInited.length) {
                $carouselToBeInited.removeClass(carouselOptions.skipClass.substring(1));
                carousel.initCarousel($carouselToBeInited);
            }
        }
    });
}
module.exports.init = function () {
    if (initialized) {
        return;
    }

    addProductToCart();
    initializeEvents();
    initialized = true;
};
